export default class Roles {
    public static readonly leitor: string = "Leitor";
    public static readonly atendente: string = "Atendente";
    public static readonly gestor: string = "Gestor";
}